import { RestRequestGET } from 'libs/RestRequest'
import Endpoints from 'constants/Endpoints'
import {setClientColors, setResource} from 'redux/actions';
import reduxStore from 'redux/store'

const logo = async () => {
	try {
		const res = await RestRequestGET(Endpoints.CLIENT_LOGO);
		reduxStore.dispatch(setResource('logo', res))
	} catch (error) {
	}
}

const clientColors = async () => {
	try {
		const res = await RestRequestGET(Endpoints.CLIENT_COLORS);
		reduxStore.dispatch(setClientColors(res))
		return res;
	} catch (error) {
	}
}

export default {
	logo,
	clientColors
}